import type { HeaderContent } from '@/blocks/domain/types';
import type { TemplateLogoAlignment, TemplateLogoSize } from '@/templates/domain/types/TemplateLogo';
import type { RendererProps } from '../../domain/RendererContract';
import { readDocumentBranding, readResolvedLogoUrlFromContext } from '../../application/documentBranding';
import { FieldsBlockRender } from './FieldsBlockRender';

type Props = RendererProps<HeaderContent>;

function readHeaderLogo(context: RendererProps['context']): {
  url: string | null;
  size: TemplateLogoSize;
  alignment: TemplateLogoAlignment;
} | null {
  const branding = readDocumentBranding(context);
  if (branding.logoPosition !== 'header') return null;
  const url = readResolvedLogoUrlFromContext(context);
  if (!url) return null;
  return {
    url,
    size: branding.logoSize ?? 'medium',
    alignment: branding.logoAlignment ?? 'left'
  };
}

function HeaderRenderImpl({ content, style, context, accentColor, knownPaths }: Props) {
  const headerLogo = readHeaderLogo(context);

  return (
    <FieldsBlockRender
      fields={content.fields ?? []}
      style={style}
      context={context}
      accentColor={accentColor}
      knownPaths={knownPaths}
      ariaLabel="block-header"
      logoUrl={headerLogo?.url}
      logoSize={headerLogo?.size}
      logoAlignment={headerLogo?.alignment}
      sections={content.sections}
      columns={content.columns}
    />
  );
}

export const renderer = {
  Component: HeaderRenderImpl,
  flowBehavior: 'atomic' as const
};

export type { HeaderContent };
